module.exports = __webpack_public_path__ + "img/91757.5f0590c7.svg";